// extracted by mini-css-extract-plugin
export default {"root":"TableCountPicker_root__tdzDd","segment":"TableCountPicker_segment__PxRNA","segmentActive":"TableCountPicker_segmentActive__jRN3k"};